import CommonHeader, { TabConfig } from '@/components/common/CommonHeader';
import { palette } from '@/modules/defines/styles';

const tabs: TabConfig[] = [
  { label: '공간 관리', path: '/space' },
  { label: '통계', path: '/data' },
];

const AvnfrGGHeader = () => {
  return (
    <CommonHeader
      title="아브뉴프랑 광교 ADMIN"
      backgroundColor={palette.mainAvnfr}
      hoverColor={palette.mainAvnfrHover}
      tabs={tabs}
      sessionCode="avnfr-gg"
      baseRoute="/avnfr-gg"
    />
  );
};

export default AvnfrGGHeader;
